import { useEffect, useRef, useState } from "react"

export function useEllipsisAnimation() {
  const [ellipsisActive, setEllipsisActive] = useState(false)
  const [liveSportsTrending, setLiveSportsTrending] = useState(false)
  const [typingStarted, setTypingStarted] = useState(false)
  const ellipsisRef = useRef<HTMLSpanElement | null>(null)
  const heroSeenRef = useRef(false)

  useEffect(() => {
    if (ellipsisActive && typeof window !== "undefined" && window.innerWidth >= 640) {
      setLiveSportsTrending(true)
    }
  }, [ellipsisActive])

  useEffect(() => {
    const node = ellipsisRef.current
    if (!(node && liveSportsTrending)) return

    const handleEnd = () => {
      setLiveSportsTrending(false)
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent("ellipsisSequenceComplete"))
      }, 700)
    }
    node.addEventListener("animationend", handleEnd, { once: true })
    return () => node.removeEventListener("animationend", handleEnd)
  }, [liveSportsTrending])

  useEffect(() => {
    const handleTypingStart = () => {
      setTypingStarted(true)
      setLiveSportsTrending(false)
    }
    window.addEventListener("landingTypingStarted", handleTypingStart)
    return () => window.removeEventListener("landingTypingStarted", handleTypingStart)
  }, [])

  return {
    ellipsisActive,
    setEllipsisActive,
    liveSportsTrending,
    setLiveSportsTrending,
    typingStarted,
    ellipsisRef,
    heroSeenRef,
  }
}
